import type { TemplateBase } from "@expert/expert-university";

import {
    getLearningBlockLabel,
    LEARNING_BLOCK_TITLES,
    UNASSIGNED_GROUP_KEY,
    UNASSIGNED_GROUP_LABEL,
} from "./learningBlocks";

export interface LearningBlockGroup {
    key: string;
    label: string;
    profiles: TemplateBase[];
    isUnassigned: boolean;
}

// Shared empty sentinel so every empty block returns the same reference (referential stability).
const EMPTY_PROFILES: TemplateBase[] = [];

export function groupProfilesByLearningBlock(profiles: TemplateBase[] | undefined): LearningBlockGroup[] {
    const buckets = new Map<number, TemplateBase[]>();
    const unassigned: TemplateBase[] = [];

    for (const profile of profiles ?? []) {
        const block = profile.learningBlock;
        if (block !== undefined && block >= 1 && block <= LEARNING_BLOCK_TITLES.length) {
            const bucket = buckets.get(block);
            if (bucket) {
                bucket.push(profile);
            } else {
                buckets.set(block, [profile]);
            }
        } else {
            unassigned.push(profile);
        }
    }

    const groups: LearningBlockGroup[] = LEARNING_BLOCK_TITLES.map((_, index) => {
        const block = index + 1;
        return {
            key: String(block),
            label: getLearningBlockLabel(block),
            profiles: buckets.get(block) ?? EMPTY_PROFILES,
            isUnassigned: false,
        };
    });

    if (unassigned.length > 0) {
        groups.push({
            key: UNASSIGNED_GROUP_KEY,
            label: UNASSIGNED_GROUP_LABEL,
            profiles: unassigned,
            isUnassigned: true,
        });
    }

    return groups;
}
